/**
 * API cliente — Proyectos de obra (Materialidad MVP).
 * Solo endpoints /tramites/materialidad/projects*; no SAT.
 */
import api from "@/lib/api";

const BASE = "/tramites/materialidad/projects";

export async function fetchMaterialidadProjects({ clientId, status, q } = {}) {
  const params = {};
  if (clientId) params.client_id = clientId;
  if (status) params.status = status;
  if (q) params.q = q;
  const { data } = await api.get(BASE, { params, timeout: 30000 });
  return data;
}

export async function createMaterialidadProject(payload) {
  const { data } = await api.post(BASE, payload, { timeout: 30000 });
  return data;
}

export async function fetchMaterialidadProject(projectId) {
  const { data } = await api.get(`${BASE}/${projectId}`, { timeout: 30000 });
  return data;
}

export async function patchMaterialidadProject(projectId, payload) {
  const { data } = await api.patch(`${BASE}/${projectId}`, payload, { timeout: 30000 });
  return data;
}

export async function archiveMaterialidadProject(projectId) {
  const { data } = await api.post(`${BASE}/${projectId}/archive`, {}, { timeout: 20000 });
  return data;
}

export async function addMaterialidadProjectProvider(projectId, payload) {
  const { data } = await api.post(`${BASE}/${projectId}/providers`, payload, { timeout: 20000 });
  return data;
}

export async function removeMaterialidadProjectProvider(projectId, providerId) {
  const { data } = await api.delete(`${BASE}/${projectId}/providers/${providerId}`, { timeout: 20000 });
  return data;
}

export async function linkMaterialidadProjectCfdi(projectId, { uuid, providerId } = {}) {
  const { data } = await api.post(
    `${BASE}/${projectId}/cfdi-links`,
    { uuid, provider_id: providerId || null },
    { timeout: 20000 },
  );
  return data;
}

export async function unlinkMaterialidadProjectCfdi(projectId, cfdiUuid) {
  const { data } = await api.delete(`${BASE}/${projectId}/cfdi-links/${encodeURIComponent(cfdiUuid)}`, {
    timeout: 20000,
  });
  return data;
}

export async function fetchMaterialidadProjectCfdiCandidates(projectId, { q, rfc, limit } = {}) {
  const params = {};
  if (q) params.q = q;
  if (rfc) params.rfc = rfc;
  if (limit) params.limit = limit;
  const { data } = await api.get(`${BASE}/${projectId}/cfdi-candidates`, { params, timeout: 30000 });
  return data;
}

export async function uploadMaterialidadProjectDocument(projectId, { file, documentType, providerId, notes } = {}) {
  const form = new FormData();
  form.append("file", file);
  const params = { document_type: documentType };
  if (providerId) params.provider_id = providerId;
  if (notes) params.notes = notes;
  const { data } = await api.post(`${BASE}/${projectId}/documents`, form, {
    params,
    timeout: 60000,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export function materialidadProjectDocumentFileUrl(projectId, documentId) {
  return `/api${BASE}/${projectId}/documents/${documentId}/file`;
}
